module.exports = __webpack_public_path__ + "static/media/register-banner.dc03fd77.svg";